export enum UserRoleType {
  Student = "ROLE_STUDENT",
  Author = "ROLE_AUTHOR",
}
